import React, { Component } from "react"
import { Modal, ModalBody, ModalHeader, UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem, ModalFooter } from "reactstrap"
import helper from "../utils/helper"
import cfg from "../utils/config"
import auth from "../utils/auth"
import axios from "axios"

class CardErrorParametrizacao extends Component {
    userInfo = auth.getUserInfo()
    configMe = { headers: { 'Authorization': 'Bearer ' + auth.getToken() } }
    baseUrl = cfg.base_api_url + cfg.api_v2


    state = {
        modalDelete: false,
        keyDelete: false
    }

    showMotivo = (motivo) => {
        helper.dispatchEvent("showAviso", { message: motivo })
    }
    
    handleInlineChange = (field, value) => {
        const { cardsErrors, setCardsErrors, index } = this.props
        const updated = [...cardsErrors]
        const newItem = { ...(updated[index] || {}) }
        newItem[field] = value
        if (field === 'descricao') {
            newItem.identificacao = helper.toSnakeCase(value)
        }
        updated[index] = newItem
        setCardsErrors(updated)
    }

    import = (parametrizacao, index_parametrizacao) => {
        const parametro = [
            {
                descricao: parametrizacao.descricao,
                formula: parametrizacao.formula,
                unidade: parametrizacao.unidade,
                identificacao: parametrizacao.identificacao,
                mascara: parametrizacao.mascara,
                decimal: parametrizacao.decimal,
                operador_especial: parametrizacao.operador_especial,
                prioridade: parametrizacao.prioridade,
                tipo_dado_saida: parametrizacao.tipo_dado_saida,
                tipo_grafico: parametrizacao.tipo_grafico,
                icone: parametrizacao.icone,
                configuracao: parametrizacao.configuracao
            }
        ]

        const url = `${this.baseUrl}/${this.userInfo.empresa}/equipamento/${this.props.equipamentoId}/parametros/importar/`
        const body_data = {'parametros': parametro}

        axios({
            url: url,
            method: "POST",
            headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + auth.getToken() },
            data: body_data
        })
        .then(data => {
            const { erros, quantidade_permitida, sucessos } = data.data
            let cardsErrors = this.props.cardsErrors

            if(erros.length > 0) {
                const message_error = erros[0].motivo_erro
                helper.dispatchEvent("showAviso", { message: message_error })

                const updated = [...cardsErrors]
                updated[index_parametrizacao] = { ...updated[index_parametrizacao], ...erros[0] }
                this.props.setCardsErrors(updated)
            } else {
                const updated = cardsErrors.filter((_, index) => index !== index_parametrizacao)
                this.props.setCardsErrors(updated)
                this.props.getParametros()
            }
        })
        .catch(error => {
            const message_error = error?.response?.data?.detail ?? "Não foi possível importar os parâmetros."
            helper.dispatchEvent("showAviso", { message: message_error })
        })
    }

    delete = () => {
        const { keyDelete } = this.state
        let { cardsErrors, setCardsErrors } = this.props
        cardsErrors = cardsErrors.filter((_, index) => index !== keyDelete)
        setCardsErrors(cardsErrors)

        this.setState({ keyDelete: false, modalDelete: false })
    }

    render() {
        const { parametrizacao, index } = this.props

        return(
            <>
                <Modal isOpen={this.state.modalDelete} toggle={() => this.setState({ modalDelete: !this.state.modalDelete })}>
                    <ModalHeader>Confirmar exclusão</ModalHeader>
                    <ModalBody>
                        <p style={{ fontSize: '14px' }}>Você tem certeza que deseja deletar? Essa ação não poderá ser desfeita</p>
                    </ModalBody>
                    <ModalFooter>
                        <div className="float-right" style={{ marginTop: '20px' }}>
                            <button onClick={() => this.setState({ modalDelete: false, keyDelete: false })} className="hdv-btn-forms hdv-btn-yellow">Cancelar</button>
                            <button onClick={this.delete} className="hdv-btn-forms hdv-btn-red">Confirmar</button>
                        </div>
                    </ModalFooter>
                </Modal>

                <div className="parametrizacao-btn-editar">
                    <div style={{ height: "90%" }}>
                        <div className="pt-3 text-truncate parametrizacao-title" >
                            <input
                                type="text"
                                className={!parametrizacao.descricao?.trim() ? 'has-error' : ''}
                                value={parametrizacao.descricao ?? ''}
                                onChange={(e) => this.handleInlineChange('descricao', e.target.value)}
                            />
                            <div style={{ marginTop: '8px' }}>
                                <small><strong>{parametrizacao.identificacao}</strong></small>
                            </div>
                        </div>

                        <div className="row mt-4">
                            <div className="col-md-6 pl-4">
                                {(parametrizacao.tipo_grafico === "barra")
                                    ?
                                    <i className="fa fa-chart-bar" id="chart-type"></i>
                                    :
                                    <i className="fa fa-chart-line" id="chart-type"></i>
                                }
                                <br />
                                <span>Tipo Gráfico</span>
                            </div>
                            <div className="col-md-6 pr-4">
                                <strong style={{ fontSize: "17px" }}>({parametrizacao.unidade})</strong>
                                <br />
                                <span>Unidade</span>
                            </div>
                        </div>
                    </div>

                    <UncontrolledDropdown direction="down">
                        <DropdownToggle nav>
                            <div className="btns-parametrizacao-novo" style={{ background: "#fda500" }}> 
                                <span style={{ textAlign: "center", padding: "6px", fontSize: "13px" }}>Não importado: Ações</span>
                            </div>
                        </DropdownToggle>
                        <DropdownMenu className="mini-modal">
                            <DropdownItem onClick={() => this.showMotivo(parametrizacao.motivo_erro)}>
                                <i className="las la-eye"></i> Visualizar Motivo
                            </DropdownItem>
                            <DropdownItem disabled={!parametrizacao.descricao?.trim()} onClick={() => this.import(parametrizacao, index)}>
                                <i className="las la-cloud-upload-alt"></i> Importar Novamente
                            </DropdownItem>
                            <DropdownItem onClick={() => this.setState({ modalDelete: true, keyDelete: index })}>
                                <i className="fa fa-times"></i> Excluir
                            </DropdownItem>
                        </DropdownMenu>
                    </UncontrolledDropdown>
                </div>
            </>
        )
    }
}

export default CardErrorParametrizacao